import React, {
  useState,
  useContext,
  useEffect,
  Fragment,
  useReducer,
} from "react";
// import * as con from '../../repository/api_calls';
import { useNavigate } from "react-router-dom";
import { UserContext } from "./exp";
import Teeth from "./Teeth";
import ChildTeeth from "./ChildTeeth";
import * as values from "./exp";
import { DiagnosisList, DiagnosisTypeList } from "../../../../../apiController";

const predefinedColors = [
  "#F7C8E0",
  "#FFEEBB",
  "#C4DFDF",
  "#D7C0AE",
  "#D7E9F7",
  "#BFACE2",
  // Add more colors as needed
];

const style = {
  fontSize: "17px",
  backgroundColor: "#D3DCEB",
  color: "#145BD9",
  padding: " 1px 20px",
  borderRadius: "10px",
};

function treatmentReducer(treatmentState, action) {
  switch (action.type) {
    case "UPDATE_TREATMENT_PLAN":
      return {
        ...treatmentState,
        summary: {
          ...treatmentState.summary,
          treatmentPlan: action.payload,
        },
      };
    case "UPDATE_TREATMENT_PROCEDURE":
      return {
        ...treatmentState,
        summary: {
          ...treatmentState.summary,
          treatmentProcedure: action.payload,
        },
      };
    case "UPDATE_TREATMENT_METHOD":
      return {
        ...treatmentState,
        summary: {
          ...treatmentState.summary,
          treatmentMethod: action.payload,
        },
      };
    case "UPDATE_TREATMENT_PRICE":
      return {
        ...treatmentState,
        summary: {
          ...treatmentState.summary,
          treatmentPrice: action.payload,
        },
      };
    default:
      return treatmentState;
  }
}

const Dental = ({ data }) => {
  const navigate = useNavigate();

  const [selectedGeneral, setSelectedGeneral] = useState([]);
  const [selectedTeeth, setSelectedTeeth] = useState([]);
  const [problem, setProblem] = useState([]);
  const [toothNo, setToothNo] = useState([]);
  const [toothIndex, setToothIndex] = useState([]);
  const [selectedActiveTooth, setselectedActiveTooth] = useState(0);
  const initialState = {
    tooth_data: selectedTeeth,
    summary: {
      treatmentPlan: "",
      treatmentProcedure: "",
      treatmentMethod: "",
      treatmentPrice: "",
    },
  };
  const [dianosesType, setDiagnosesType] = useState([]);
  const [diagnoses, setDiagnoses] = useState([]);
  const [emptyList, setEmptyList] = useState([
    {
      id: 0,
      name: "Crowd Spacing",
    },
    {
      id: 1,
      name: "Fracture",
    },
    {
      id: 2,
      name: "Aberrant Frenum",
    },
    {
      id: 3,
      name: "Fibrosis",
    },
    {
      id: 4,
      name: "Complete tdentulis",
    },
  ]);
  const [actTab, setActTab] = useState("Tooth Table");
  const contextValue = useContext(UserContext);

  //   const userRoleId = localStorage.getItem('role_id');

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [actTab2, setActTab2] = useState("");
  // const [specificPlan, setSpecificPlan] = useState([])

  const handleTab = (e) => {
    e.preventDefault();
    setActTab2(e.target.name);
    // getDiagnosisName()
  };

  const teethValues = [
    [
      {
        teeth_id: "1",
        teeth_no: 18,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "2",
        teeth_no: 17,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "3",
        teeth_no: 16,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "4",
        teeth_no: "15/55",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "5",
        teeth_no: "14/54",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "6",
        teeth_no: "13/53",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "7",
        teeth_no: "12/52",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "8",
        teeth_no: "11/51",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "9",
        teeth_no: "21/61",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "10",
        teeth_no: "22/62",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "11",
        teeth_no: "23/63",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "12",
        teeth_no: "24/64",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "13",
        teeth_no: "25/65",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "14",
        teeth_no: 26,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "15",
        teeth_no: 27,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "16",
        teeth_no: 28,
        teeth_stroke: "none",
        selected_teeth: [],
      },
    ],
    [
      {
        teeth_id: "17",
        teeth_no: 48,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "18",
        teeth_no: 47,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "19",
        teeth_no: 46,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "20",
        teeth_no: "45/85",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "21",
        teeth_no: "44/84",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "22",
        teeth_no: "43/83",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "23",
        teeth_no: "42/82",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "24",
        teeth_no: "41/81",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "25",
        teeth_no: "31/71",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "26",
        teeth_no: "32/72",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "27",
        teeth_no: "33/73",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "28",
        teeth_no: "34/74",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "29",
        teeth_no: "35/75",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "30",
        teeth_no: 36,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "31",
        teeth_no: 37,
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "32",
        teeth_no: 38,
        teeth_stroke: "none",
        selected_teeth: [],
      },
    ],
  ];

  const childTeethValues = [
    [
      {
        teeth_id: "1",
        teeth_no: "55",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "2",
        teeth_no: "54",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "3",
        teeth_no: "53",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "4",
        teeth_no: "52",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "5",
        teeth_no: "51",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "6",
        teeth_no: "61",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "7",
        teeth_no: "62",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "8",
        teeth_no: "63",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "9",
        teeth_no: "64",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "10",
        teeth_no: "65",
        teeth_stroke: "none",
        selected_teeth: [],
      },
    ],
    [
      {
        teeth_id: "11",
        teeth_no: "85",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "12",
        teeth_no: "84",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "13",
        teeth_no: "83",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "14",
        teeth_no: "82",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "15",
        teeth_no: "81",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "16",
        teeth_no: "71",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "17",
        teeth_no: "72",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "18",
        teeth_no: "73",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "19",
        teeth_no: "74",
        teeth_stroke: "none",
        selected_teeth: [],
      },
      {
        teeth_id: "20",
        teeth_no: "75",
        teeth_stroke: "none",
        selected_teeth: [],
      },
    ],
  ];

  function diseasesG(name, t) {
    const isSelected = selectedGeneral.some(
      (problemItem) => problemItem.id === t.id
    );
    // console.log(isSelected)
    if (isSelected) {
      setSelectedGeneral((prevSelected) =>
        prevSelected.filter((item) => item.id !== t.id)
      );
    } else {
      setSelectedGeneral([...selectedGeneral, t]);
    }
  }

  function deselectGeneral(name) {
    setSelectedGeneral((prevSelected) =>
      prevSelected.filter((item) => item.id !== name.id)
    );
  }

  const diseases = (selectedDisease, t) => {
    setSelectedTeeth((prevTeeth) =>
      prevTeeth.map((tooth) => {
        if (tooth.tooth == selectedActiveTooth) {
          const idExists = tooth.problem.some(
            (problemItem) => problemItem.id === t.id
          );
          if (!idExists) {
            tooth.problem.push(t);
          } else {
            tooth.problem = tooth.problem.filter(
              (problemItem) => problemItem.id !== t.id
            );
          }
        }

        return tooth;
      })
    );
  };

  const handleClick = (tooth, index, toothInfo) => {
    const newTooth = {
      tooth: tooth,
      index: index,
      problem: [],
      teeth_id: toothInfo,
    };
    const idList = selectedTeeth.map((teeth) => teeth.tooth);
    if (!idList.includes(tooth)) {
      setSelectedTeeth([...selectedTeeth, newTooth]);
      setToothNo([...toothNo, tooth]);
      setToothIndex([...toothIndex, index]);
    }
    setselectedActiveTooth(tooth);
  };

  const handleRemove = (index, prob) => {
    let updatedTeeth = [...selectedTeeth];
    const updatedList = updatedTeeth[index].problem.filter((id) => id !== prob);
    updatedTeeth[index].problem = updatedList;
    // updatedTeeth.reduce(index, 1);
    // console.log(updatedTeeth)
    setSelectedTeeth(updatedTeeth);
  };

  const handleRemoveList = (tooth, index) => {
    for (let i = 0; i < values.teethValues.length; i++) {
      if (values.teethValues[i]["teeth_id"] === index.teeth_id) {
        values.teethValues[i]["teeth_stroke"] = "none";
      }
    }

    const updatedTeeth = [...selectedTeeth];
    updatedTeeth.splice(tooth, 1);
    setSelectedTeeth(updatedTeeth);

    const updatedToothNo = [...toothNo];
    updatedToothNo.splice(tooth, 1);
    setToothNo(updatedToothNo);

    const updatedToothIndex = [...toothIndex];
    updatedToothIndex.splice(tooth, 1);
    setToothIndex(updatedToothIndex);
  };

  function save(e) {
    e.preventDefault();

    contextValue.toothSelection = [];
    contextValue.patient_id = data.id;
    console.log(selectedGeneral);
    if (selectedGeneral.length !== 0) {
      for (let i of selectedGeneral) {
        contextValue.toothSelection.push({ type: "general", problem: i });
      }
    }
    if (selectedTeeth.length !== 0) {
      let data = contextValue.toothSelection;
      for (let i = 0; i < selectedTeeth.length; i++) {
        for (let j = 0; j < selectedTeeth[i]["problem"].length; j++) {
          let dataa = {
            type: "tooth",
            problem: selectedTeeth[i]["problem"][j],
            tooth: selectedTeeth[i]["tooth"],
          };
          data.push(dataa);
        }
      }
      contextValue.toothSelection = data;
    }

    navigate("/patientinfo/treatment-plan", { state: { data: data } });
  }

  const fetchType = async () => {
    const response = await DiagnosisTypeList();
    if (response.status === true) {
      setDiagnosesType(response.data);
    }
  };
  const fetchDiagnosis = async () => {
    const response = await DiagnosisList();
    if (response.status === true) {
      setDiagnoses(response.data);
    }
  };

  useEffect(() => {
    fetchType();
    fetchDiagnosis();
  }, []);

  const handleTabTooth = (e) => {
    e.preventDefault();
    setActTab(e.target.name);
  };

  const generalDiagnoses = diagnoses.filter((d) => d.dname === "General");
  const toothSpecificDiagnoses = diagnoses.filter(
    (d) => d.dname === "Tooth Specific"
  );
  const otherDiagnoses = diagnoses.filter(
    (d) => !["General", "Tooth Specific"].includes(d.dname)
  );

  return (
    <Fragment>
      <>
        <div className="visible treatment-tab">
          <>
            {/* <div className="container-fluid generalDentistry"> */}
            <div className="container-fluid my-5">
              <p className="diagnosisType">
                {" "}
                <b>GENERAL DENTISTRY</b>
              </p>
              <div className="container-fluid mt-5">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {generalDiagnoses.map((t, index) => {
                    //   {gen.map((t, index) => {
                    const backgroundColor =
                      predefinedColors[index % predefinedColors.length];
                    const style = {
                      height: "auto",
                      width: "auto",
                      borderRadius: "7px",
                      marginRight: "5px",
                      padding: "3px 10px",
                      backgroundColor: backgroundColor,
                      cursor: "pointer",
                    };
                    return (
                      <span className="my-3">
                        <a
                          onClick={() => diseasesG(t.name, t)}
                          className={`diagnosisNameList${
                            selectedGeneral.includes(t.name) ? " selected" : ""
                          }`}
                          style={style}
                        >
                          {t.name}
                        </a>
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="container-fluid my-5">
              <p className="diagnosisType">
                <b>OTHERS</b>
              </p>
              <div className="container-fluid mt-5">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {otherDiagnoses.map((t, index) => {
                    const backgroundColor =
                      predefinedColors[index % predefinedColors.length];
                    const style = {
                      height: "auto",
                      width: "auto",
                      borderRadius: "7px",
                      marginRight: "5px",
                      padding: "3px 10px",
                      backgroundColor: backgroundColor,
                      cursor: "pointer",
                    };
                    return (
                      <span className="my-3" key={t.name}>
                        <a
                          onClick={() => diseasesG(t.name, t)}
                          className={`diagnosisNameList${
                            selectedGeneral.includes(t.name) ? " selected" : ""
                          }`}
                          style={style}
                        >
                          {t.name}
                        </a>
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </>

          <>
            <div className="container-fluid mb-5">
              {/* <div className="container-fluid tabtablediagno mb-5"> */}
              <p className="diagnosisType ">
                {" "}
                <b>TOOTH SPECIFIC</b>
              </p>
              <div className="nav-tab">
                <ul className="nav nav-tabs d-flex gap-5 justify-content-start">
                  <li className="nav-item">
                    <a
                      className={
                        actTab === "Tooth Table" ? `nav-item act` : "nav-item"
                      }
                      href="#"
                      name="Tooth Table"
                      onClick={handleTabTooth}
                    >
                      Tooth Table
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={
                        actTab === "Graphic" ? `nav-item act` : "nav-item"
                      }
                      href="#treatment"
                      name="Graphic"
                      onClick={handleTabTooth}
                    >
                      Graphic
                    </a>
                  </li>
                </ul>
              </div>
              <table
                className="container-fluid "
                style={{ width: "100%", padding: "8px" }}
              >
                <tbody>
                  <div
                    className={
                      actTab === "Tooth Table"
                        ? "d-flex justify-content-center align-items-center w-100 columns mt-5"
                        : "row"
                    }
                  >
                    <div className={actTab === "Tooth Table" ? "" : "col-6"}>
                      {actTab === "Graphic" ? (
                        //  7 > 6 ?
                        data.age > 6 ? (
                          <Teeth
                            toothInd={toothIndex}
                            toothSelFunc={handleClick}
                          />
                        ) : (
                          <ChildTeeth toothSelFunc={handleClick} />
                        )
                      ) : data.age > 6 ? (
                        teethValues.map((row, rowIndex) => (
                          //   props.pData.age > 6 ? teethValues.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                              <td
                                key={cellIndex}
                                style={{
                                  backgroundColor: `${
                                    toothNo.includes(cell.teeth_no) &&
                                    selectedActiveTooth != cell.teeth_no
                                      ? "#4E4C67"
                                      : toothNo.includes(cell.teeth_no) &&
                                        selectedActiveTooth == cell.teeth_no
                                      ? "#B4869F"
                                      : "white"
                                  }`,
                                  fontSize: "16px",
                                  // color: "black",
                                  color: `${
                                    toothNo.includes(cell.teeth_no) &&
                                    selectedActiveTooth != cell.teeth_no
                                      ? "#fff"
                                      : "#111"
                                  }`,
                                  border: "1px solid black",
                                  cursor: "pointer",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  padding: "10px",
                                }}
                                onClick={() => {
                                  handleClick(cell.teeth_no);
                                }}
                              >
                                {cell.teeth_no}
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : (
                        childTeethValues.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                              <td
                                key={cellIndex}
                                style={{
                                  backgroundColor: `${
                                    toothNo.includes(cell.teeth_no) &&
                                    selectedActiveTooth != cell.teeth_no
                                      ? "#4E4C67"
                                      : toothNo.includes(cell.teeth_no) &&
                                        selectedActiveTooth == cell.teeth_no
                                      ? "#B4869F"
                                      : "white"
                                  }`,
                                  fontSize: "16px",
                                  // color: "black",
                                  color: `${
                                    toothNo.includes(cell.teeth_no) &&
                                    selectedActiveTooth != cell.teeth_no
                                      ? "#fff"
                                      : "#111"
                                  }`,
                                  border: "1px solid black",
                                  cursor: "pointer",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  padding: "10px",
                                }}
                                onClick={() => {
                                  handleClick(cell.teeth_no);
                                }}
                              >
                                {cell.teeth_no}
                              </td>
                            ))}
                          </tr>
                        ))
                      )}
                    </div>
                    {actTab === "Graphic" ? (
                      <div className="col-4">
                        <div
                          className="container-fluid toothSpecificName tabtablediagno"
                          style={{ display: "flex", flexWrap: "wrap" }}
                        >
                          {toothSpecificDiagnoses.map((t, index) => {
                            // {toothSpecific.map((t, index) => {

                            const backgroundColor =
                              predefinedColors[index % predefinedColors.length];

                            const styles = {
                              height: "auto",
                              width: "auto",
                              borderRadius: "7px",
                              marginRight: "5px",
                              padding: "3px 10px",
                              // backgroundColor: "none",
                              backgroundColor: backgroundColor,
                              cursor: "pointer",
                              // border: selectedTeeth.includes(t.name) ? '2px solid blue' : 'none'
                            };
                            return (
                              <a
                                onClick={() => diseases(t.name, t)}
                                // className={`diagnosisNameList${selectedTeeth.includes(t.name) ? ' selected' : ''}`}
                                style={styles}
                                className="diagnosisNameList"
                              >
                                {t.name}
                              </a>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </tbody>
              </table>
            </div>

            {actTab === "Graphic" ? (
              ""
            ) : (
              <div
                className="container-fluid toothSpecificName tabtablediagno"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginLeft: "1.5rem",
                }}
              >
                {toothSpecificDiagnoses.map((t, index) => {
                  const backgroundColor =
                    predefinedColors[index % predefinedColors.length];

                  const styles = {
                    height: "auto",
                    width: "auto",
                    borderRadius: "7px",
                    marginRight: "5px",
                    padding: "3px 10px",
                    backgroundColor: backgroundColor,
                    cursor: "pointer",
                  };
                  return (
                    <a
                      onClick={() => diseases(t.name, t)}
                      // className={`diagnosisNameList${selectedTeeth.includes(t.name) ? ' selected' : ''}`}
                      className="diagnosisNameList"
                      style={styles}
                    >
                      {t.name}
                    </a>
                  );
                })}
              </div>
            )}

            {/* <div className="container-fluid diagnosisSelList"> */}
            <div className="container-fluid my-5 ">
              <>
                <div>
                  <h5
                    style={{
                      marginTop: "25px",
                      font: "Gilroy-Bold",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#1C1C22",
                    }}
                  >
                    SELECTED DIAGNOSIS
                  </h5>

                  <table
                    style={{
                      border: "2px solid #EAECF0",
                      backgroundColor: "#ffffff",
                      width: "100%",
                    }}
                  >
                    <thead></thead>
                    <tbody>
                      {selectedTeeth.length > 0 && (
                        <>
                          {selectedTeeth.map((tooth, index) => (
                            <tr style={{ height: "50px" }}>
                              <td
                                style={{
                                  border: "2px solid #EAECF0",
                                  paddingLeft: "30px",
                                  width: "10px",
                                }}
                              >
                                {" "}
                                <span className="tablevalue_round">
                                  {tooth.tooth}
                                </span>
                              </td>
                              <td className="selectedDiagnosis">
                                <span>
                                  {tooth.problem !== null
                                    ? tooth.problem.map((tee, ind) => (
                                        <span
                                          // className="selectedDiagnosis"
                                          style={{
                                            color: "#BB3504",
                                            backgroundColor: "#F5F6F9",
                                            // padding: '10px, 20px',
                                            borderRadius: "3px",
                                            margin: "10px",
                                            display: "inline-block",
                                            font: "Gilroy-Bold",
                                            gap: "10px",
                                            lineHeight: "16.41px",
                                            font: "Gilroy-Bold",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <span
                                          // style={{ padding: '40px 8px 40px 5px' }}
                                          >
                                            {tee.name}
                                            <button
                                              className="diagnosisClose"
                                              onClick={() =>
                                                handleRemove(index, tee)
                                              }
                                            >
                                              x
                                            </button>
                                          </span>
                                        </span>
                                      ))
                                    : null}
                                </span>
                                {/* <span className="teethClose"> */}
                                <span>
                                  <button
                                    className="teethClose"
                                    onClick={() =>
                                      handleRemoveList(index, tooth)
                                    }
                                  >
                                    x
                                  </button>
                                </span>
                              </td>
                            </tr>
                          ))}
                        </>
                      )}
                    </tbody>
                    {selectedGeneral.length > 0 && (
                      <tfoot>
                        <tr style={{ height: "50px" }}>
                          <td
                            style={{
                              border: "2px solid #EAECF0",
                              fontSize: "15px",
                              font: "Gilroy-Bold",
                              fontWeight: "bold",
                              color: "#1C1C22",
                              width: "30px",
                              paddingLeft: "30px",
                            }}
                          >
                            General
                          </td>

                          <td
                            style={{
                              border: "2px solid #EAECF0",
                              width: "250px",
                              padding: "10px, 20px",
                            }}
                          >
                            {selectedGeneral.map((value, index) => (
                              <span
                                key={index}
                                style={{
                                  color: "#10902C",
                                  backgroundColor: "#F5F6F9",
                                  padding: "10px, 20px",
                                  borderRadius: "3px",
                                  margin: "10px",
                                  font: "Gilroy-Bold",
                                  gap: "10px",
                                  lineHeight: "20.41px",
                                  fontWeight: "bold",
                                }}
                              >
                                <span style={{ padding: "40px 8px 40px 5px" }}>
                                  {value.name}{" "}
                                  <button
                                    onClick={() => deselectGeneral(value)}
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                      cursor: "pointer",
                                      color: "#808080",
                                      fontWeight: "bold",
                                      marginLeft: "10px",
                                      fontSize: "18px",
                                    }}
                                  >
                                    x
                                  </button>
                                </span>
                              </span>
                            ))}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </>
              <div
                className="nxt-btn"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <button
                  className="btn btn-primary"
                  onClick={save}
                  style={{
                    color: "white",
                    padding: "5px 20px",
                    borderRadius: "10px",
                    marginTop: "8px",
                    marginRight: "11vh",
                    marginBottom: "5vh",
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </>
        </div>
      </>
    </Fragment>
  );
};

export default Dental;
